import { render, staticRenderFns } from "./PacketComponent.vue?vue&type=template&id=8545cc3c&"
import script from "./PacketComponent.vue?vue&type=script&lang=js&"
export * from "./PacketComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports